import { memo, useMemo } from "react";

import { ReviewItemView } from "@react/sections/ProductReviews/ReviewItem/ReviewItem.view";
import { getReviewedOnProductName } from "@react/utilities";
import {
  type ReviewItemCommonProps,
  type GroupingData,
} from "@root/tablescape/state";

type ReviewItemDataProps = {
  createdAt: string;
  groupingData: GroupingData | undefined;
  id: number;
  productHandle: string;
} & ReviewItemCommonProps;

const ReviewItemViewBase = ({
  content,
  createdAt,
  groupingData,
  id,
  productHandle,
  reply,
  title,
  ...props
}: ReviewItemDataProps) => {
  const reviewedOnProductName = useMemo(() => {
    if (
      groupingData &&
      groupingData[id]?.product_name &&
      !groupingData[id].product_name.includes("Marketing")
    ) {
      return groupingData[id].product_name;
    }
    return getReviewedOnProductName(productHandle, createdAt) || "";
  }, [createdAt, groupingData, id, productHandle]);

  const dateFormatter = (dateText: string) => {
    const date = new Date(dateText);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(-2);
    return `${month}/${day}/${year}`;
  };

  const contentDecoder = (content: string) => {
    const doc = new DOMParser().parseFromString(content, "text/html");
    return doc?.documentElement.textContent ?? content;
  };

  return (
    <ReviewItemView
      {...props}
      content={contentDecoder(content)}
      date={dateFormatter(createdAt)}
      reply={contentDecoder(reply ?? "")}
      reviewedOnProductName={reviewedOnProductName}
      title={contentDecoder(title)}
    />
  );
};

export const ReviewItem = memo(ReviewItemViewBase);
